import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { EMPTY_OBJ, isNullOrUndefined } from 'intact-shared';
export function useFrozen() {
  var instance = useInstance();
  var inputing = useState(false);
  var originalValue = useState('');
  function startInput(e) {
    inputing.set(true);
    originalValue.set(e.target.value);
    instance.trigger('focus', e);
  }
  function endInput(e) {
    // ignore dispatch event, #523
    if (e._dispatch) return;
    var propValue = (instance.$vNode.props || EMPTY_OBJ).value;
    if (!isNullOrUndefined(propValue)) {
      // set the value as the value that parent passes to it
      instance.set({
        value: propValue
      });
    }
    inputing.set(false);
    instance.trigger('blur', e);
  }
  function onInput(e) {
    var value = e.target.value;
    instance.set({
      value: value
    });
    originalValue.set(value);
    instance.trigger('input', e);
  }
  return {
    inputing: inputing,
    originalValue: originalValue,
    startInput: startInput,
    onInput: onInput,
    endInput: endInput
  };
}